
import * as d from './components';

export const DIRECTIVES = [
  d.CwAccordion,
  d.CwActionIcon,
  d.CwAvatar,
  d.CwAvatarMenu,
  d.CwBadgeNotification,
  d.CwBadgeStatus,
  d.CwBanner,
  d.CwBreadcrumbs,
  d.CwBulletNavigation,
  d.CwButton,
  d.CwCard,
  d.CwCardList,
  d.CwCarousel,
  d.CwCarouselFooter,
  d.CwCheckbox,
  d.CwChip,
  d.CwCombobox,
  d.CwComboboxSelectItem,
  d.CwDatepicker,
  d.CwDialog,
  d.CwDivider,
  d.CwDropdown,
  d.CwDropdownGroup,
  d.CwDropdownItem,
  d.CwExpansionPanel,
  d.CwFileItem,
  d.CwFileUploader,
  d.CwHeader,
  d.CwIcon,
  d.CwImage,
  d.CwInput,
  d.CwInputAssistive,
  d.CwInputLabel,
  d.CwInputNumber,
  d.CwList,
  d.CwListItem,
  d.CwListItemDescription,
  d.CwLogo,
  d.CwMenu,
  d.CwMenuItem,
  d.CwNavigationDrawer,
  d.CwNavigationDrawerGroup,
  d.CwNavigationDrawerItem,
  d.CwNavigationDrawerSection,
  d.CwNavigationRail,
  d.CwNavigationRailGroup,
  d.CwNavigationRailItem,
  d.CwNavigationRailSection,
  d.CwNavigationRailTitle,
  d.CwPagination,
  d.CwPaginationControls,
  d.CwPopover,
  d.CwPopoverHeader,
  d.CwProgressBar,
  d.CwRadioButton,
  d.CwRadioGroup,
  d.CwSearchbar,
  d.CwSearchbarItem,
  d.CwSidebar,
  d.CwSlider,
  d.CwSnackbar,
  d.CwSnackbarItem,
  d.CwSpinner,
  d.CwSplashScreen,
  d.CwStepper,
  d.CwTab,
  d.CwTable,
  d.CwTableToggleColumn,
  d.CwTextarea,
  d.CwToggle,
  d.CwTooltip,
  d.CwWizard,
  d.CwWizardActions,
  d.CwWizardBody
];
